import React from 'react';
import { Phone, Mail, Smartphone, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom'; // ✅ use SPA navigation

const Footer = () => {
  // Fade-up animation
  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: (i: number) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.2, duration: 0.5, ease: 'easeOut' }
    })
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.3 }}
          className="grid grid-cols-1 md:grid-cols-4 gap-8"
        >
          {/* Logo and Description */}
          <motion.div
            variants={fadeUp}
            custom={0}
            className="col-span-1 md:col-span-2"
          >
            <img
              src="/logo_gani-1.png"
              alt="GANI Shirts"
              className="h-12 w-auto mb-4 filter brightness-0 invert"
            />
            <p className="text-gray-300 text-[14px] md:text-base text-justify mb-4 max-w-md">
            Known for its perfection since 1993, GANI Shirts meets the need of the modern professional with stylish classics.
            </p>
          </motion.div>

          {/* Quick Links */}
          <motion.div variants={fadeUp} custom={1}>
            <h3 className="text-lg font-semibold mb-4 text-yellow-400">
              Quick Links
            </h3>
            <ul className="space-y-2">
              {[
                { label: 'Home', path: '/' },
                { label: 'About', path: '/about' },
                { label: 'Collection', path: '/collection' },
                { label: 'New Collection', path: '/newcollection' }, // ✅ fixed path
                { label: 'Contact', path: '/contact' }
              ].map((link, i) => (
                <motion.li
                  key={link.label}
                  variants={fadeUp}
                  custom={i + 2}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false }}
                >
                  <Link
                    to={link.path}
                    className="text-[14px] text-gray-300 hover:text-yellow-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div variants={fadeUp} custom={2}>
            <h3 className="text-lg font-semibold mb-4 text-yellow-400">
              Contact Info
            </h3>
            <div className="space-y-3">
              {[
                {
                  icon: (
                    <MapPin className="w-5 h-5 text-yellow-400 mt-1 flex-shrink-0" />
                  ),
                  text: (
                    <>
                      160, Angappa Naickan Street,
                      <br />
                      Mannadi, Chennai - 600 001
                    </>
                  )
                },
                {
                  icon: <Smartphone className="w-5 h-5 text-yellow-400" />,
                  text: '+91 7810017119'
                },
                {
                  icon: <Phone className="w-5 h-5 text-yellow-400" />,
                  text: '044-42101137'
                },
                {
                  icon: <Mail className="w-5 h-5 text-yellow-400" />,
                  text: 'ganishirt1993@gmail.com'
                }
              ].map((item, i) => (
                <motion.div
                  key={i}
                  variants={fadeUp}
                  custom={i + 3}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false }}
                  className="flex items-center gap-3"
                >
                  {item.icon}
                  <span className="text-[14px] text-gray-300">{item.text}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </motion.div>

        {/* Bottom Section */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false }}
          variants={fadeUp}
          custom={7}
          className="text-[14px] border-t border-gray-800 mt-8 pt-8 text-center"
        >
          <p>
            Copyright ©{new Date().getFullYear()} All rights reserved | Developed
            by{' '}
            <a
              href="https://3rdainsmart.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 hover:text-blue-300 transition-colors"
            >
              3rd Ain Smart Infotech
            </a>
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
